const specialtySlugs = new Set([
  'orthopedics',
  'obstetrics-gynecology',
  'ophthalmology',
  'gastroenterology',
  'urology',
  'endocrinology',
  'cardiovascular',
  'internal',
  'dental-oral',
  'dermatology',
  'surgery',
  'pediatrics',
  'psychiatry',
  'pulmonology',
  'otorhinolaryngology',
  'anesthesia-and-intensive-care',
  'oncology',
  'laboratory-and-imaging',
  'general-practitioner',
  'nutrition',
  'psychology',
  'genetics',
  'emergency-medicine',
  'palliative-care',
  'infectious',
  'neurology',
  'traditional-medicine',
  'rehabilitation',
  'corona-virus',
  'pharmacology',
  'sexual-health',
  'beauty',
  'allergies',
  'diabetes',
  'imaging',
]);

/** Resolve curated icons only for specialty search routes; unknown groups keep their API image. */
export const getSpecialtyIcon = (url?: string): string | undefined => {
  const parts = url?.split(/[?#]/)[0].split('/').filter(Boolean);
  const slug = parts?.[2];
  return parts?.[0] === 's' && slug && specialtySlugs.has(slug) ? `/specialties/${slug}.webp` : undefined;
};
